module.exports = {
	"numeric": "[0-9]*",
	"name": "[a-zA-Z-,\\.\\s]+",
	"license": "^[a-zA-Z0-9]*$",
	"email": "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
	"ein": "^(0[1-9]|[1-9]\\d)-\\d{7}$",
	"ssn": "(?!(000|666|9))\\d{3}-(?!00)\\d{2}-(?!0000)\\d{4}",
	"zipCode": "[0-9]{5}(?:-[0-9]{4})?",
	"routingNumber": "[0-9]{9}",
	"phone": "\\([0-9]{3}\\)\\s[0-9]{3}-[0-9]{4}"
};


//////////////////
// WEBPACK FOOTER
// ./src/js/data/validations.json
// module id = 1
// module chunks = 0